import { styled } from '@mui/material';

import { ButtonBase } from '../ButtonBase';
import { buttonClasses } from './theme';

import type { ButtonOwnerState, ButtonProps } from './types';

export default function Button(props: ButtonProps) {
  const { children, variant = 'accent', size = 'xl', disabled = false, ...others } = props;

  const ownerState: ButtonOwnerState = { ...props, variant, size, disabled };

  return (
    <ButtonRoot
      appearance="solid"
      content="text"
      ownerState={ownerState}
      variant={variant}
      size={size}
      disabled={disabled}
      {...others}
    >
      <ButtonLabel ownerState={ownerState}>{children}</ButtonLabel>
    </ButtonRoot>
  );
}
Button.displayName = 'Button';

const ButtonRoot = styled(ButtonBase, {
  target: buttonClasses.root,
})<{ ownerState: ButtonOwnerState }>``;

const ButtonLabel = styled('span', {
  target: buttonClasses.label,
})<{ ownerState: ButtonOwnerState }>`
  ${({ ownerState }: { ownerState: ButtonOwnerState }) => {
    // Migrate label variants from theme styleOverrides
    const sizeStyles = {
      xl: 'padding: 0px 4px;',
      lg: 'padding: 0px 4px;',
      md: 'padding: 0px 4px;',
      sm: 'padding: 0px 2px;',
    };

    return sizeStyles[ownerState.size as keyof typeof sizeStyles] || sizeStyles.xl;
  }}
`;
